import useFlag from "~/config/flags";

import { AutostoreBin, Props as AutostoreBinProps } from "./AutostoreBin";
import { AutostoreBinWithAnimation } from "./AutostoreBinWithAnimation";
import { ActivityState } from "./BinState";

type Props = Omit<AutostoreBinProps, "state"> & {
  portId?: number;
  portSideIndex?: number;
  state?: ActivityState | undefined;
};

/** Returns either the standard AutostoreBin or AutostoreBinWithAnimation */
export const AutostoreBinWithAnimationFlagged = ({
  portId,
  portSideIndex,
  state,
  ...rest
}: Props) => {
  const { isBinAnimationEnabled } = useFlag();

  if (isBinAnimationEnabled) {
    if (!portId) {
      throw new Error("portId is required when isBinAnimationEnabled is true");
    }
    return (
      <AutostoreBinWithAnimation
        {...rest}
        portId={portId}
        portSideIndex={portSideIndex}
        stateOverride={state}
      />
    );
  } else {
    if (!state) {
      throw new Error("state is required when isBinAnimationEnabled is false");
    }
    return <AutostoreBin {...rest} state={state} />;
  }
};
